import React from "react";
import img1 from "../assets/trading1.webp";
import img2 from "../assets/trading2.webp";
import img3 from "../assets/trading3.jpg";
import AnimatedCarousel from "../component/animatedcarousel/animatedcarousel";
import { Container, Row, Col, Card } from "react-bootstrap";
import {
  FaChartLine,
  FaExchangeAlt,
  FaGlobe,
  FaMoneyBillWave,
} from "react-icons/fa";
import tradingInfoImg from "../assets/trading1.webp";
import "./home.css";

const Trading = () => {
  const slides = [
    {
      img: img1,
      title: "Innovative Trading Solutions",
      subtitle: "Building a Better Future Through Smart Commerce",
    },
    {
      img: img2,
      title: "Global Trade at Your Fingertips",
      subtitle: "Experience seamless cross-border transactions",
    },
    {
      img: img3,
      title: "Empowering Traders Worldwide",
      subtitle: "Trade smart. Trade securely.",
    },
  ];

  return (
    <>
      <div style={{ overflow: "hidden" }}>
        <AnimatedCarousel slides={slides} />
        <Container className="my-5 text-center">
          <h2 className="mb-4" data-aos="zoom-in">
            Our Trading Expertise
          </h2>
          <p className="mb-5" data-aos="zoom-in">
            We offer a range of trading solutions—from commodity exports to
            digital goods—enabling you to grow your business globally with
            confidence and efficiency.
          </p>
          <Row className="g-4">
            <Col md={6} lg={3} data-aos="zoom-in">
              <Card className="h-100 text-center p-3 shadow  d-flex justify-content-center align-items-center highlight-card ">
                <FaChartLine size={40} className="mb-3 text-primary" />
                <Card.Body>
                  <Card.Title>Market Analysis</Card.Title>
                  <Card.Text>
                    In-depth insights and forecasting tools to guide your
                    trading decisions.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6} lg={3} data-aos="zoom-in">
              <Card className="h-100 text-center p-3 shadow  d-flex justify-content-center align-items-center highlight-card ">
                <FaExchangeAlt size={40} className="mb-3 text-success" />
                <Card.Body>
                  <Card.Title>Efficient Trading</Card.Title>
                  <Card.Text>
                    Fast and secure trading systems for global markets and
                    commodities.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6} lg={3} data-aos="zoom-in">
              <Card className="h-100 text-center p-3 shadow  d-flex justify-content-center align-items-center highlight-card ">
                <FaGlobe size={40} className="mb-3 text-warning" />
                <Card.Body>
                  <Card.Title>Global Network</Card.Title>
                  <Card.Text>
                    Extensive partnerships across continents to facilitate
                    international trade.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6} lg={3} data-aos="zoom-in">
              <Card className="h-100 text-center p-3 shadow  d-flex justify-content-center align-items-center highlight-card ">
                <FaMoneyBillWave size={40} className="mb-3 text-danger" />
                <Card.Body>
                  <Card.Title>Secure Payments</Card.Title>
                  <Card.Text>
                    Robust financial channels ensuring trusted and swift
                    transactions.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
        <Container className="my-5">
          <Row className="align-items-center">
            <Col md={6} data-aos="zoom-in">
              <h3>Comprehensive Global Trading Services</h3>
              <p>
                Our platform connects traders, exporters, and buyers worldwide.
                We ensure transparency, compliance, and profitability through
                every stage of the trading cycle.
              </p>
              <ul>
                <li>Export-Import Solutions</li>
                <li>Real-time Analytics & Market Trends</li>
                <li>Secure Logistics & Customs Support</li>
                <li>24/7 Dedicated Support</li>
              </ul>
            </Col>
            <Col md={6} data-aos="zoom-in">
              <img
                src={tradingInfoImg}
                alt="Trading Insights"
                className="img-fluid rounded shadow"
              />
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Trading;
